const ShippingInfo = ({ order }) => (
    <div className="mt-8 p-5 border rounded-lg shadow-md bg-gray-50">
      <h3 className="text-xl font-semibold text-secondary mb-4">Shipping Information</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap:10 md:gap-20">
        <div>
          <p className="font-medium text-gray-700">Recipient Name:</p><p className="mb-2">{order.addressDetails.recipientName}</p>
          <p className="font-medium text-gray-700">Address:</p><p className="mb-2">{order.addressDetails.address}</p>
          <p className="font-medium text-gray-700">City, Province, Postal Code:</p>
          <p>{order.addressDetails.city}, {order.addressDetails.province} - {order.addressDetails.postalCode}</p>
        </div>
        <div>
          <p className="font-medium text-gray-700">Phone Number:</p><p className="mb-2">{order.addressDetails.phoneNumber}</p>
          {/* <p className="font-medium text-gray-700">Address ID:</p><p>{order.addressId}</p> */}
        </div>
      </div>
    </div>
  );

  export default ShippingInfo